import { memo } from 'react';
import { Tooltip } from '@mui/material';
import IntercomActiveIcon from 'assets/icons/CameraStream/IntercomActiveIcon';
import IntercomActiveGreyIcon from 'assets/icons/CameraStream/IntercomActiveGreyIcon';
import IntercomDeactivateIcon from 'assets/icons/CameraStream/IntercomDeactivateIcon';

import PropTypes from 'prop-types';

import styles from './Intercom.module.css';

const Intercom = ({ isIntercomActive = false, isGreyIcon = false, show, className }) => {
    if (!show) return null;

    const intercomActivateIcon = isGreyIcon ? (
        <IntercomActiveGreyIcon className={styles['intercom-icon']} />
    ) : (
        <IntercomActiveIcon className={styles['intercom-icon']} />
    );
    return (
        <Tooltip title={isIntercomActive ? 'Intercom detection is active' : 'Intercom detection is available, but not active'} placement="top">
            <span className={`${styles['intercom--wrapper']} ${className}`}>
                {isIntercomActive ? intercomActivateIcon : <IntercomDeactivateIcon className={styles['intercom-icon']} />}
            </span>
        </Tooltip>
    );
};

Intercom.propTypes = {
    isIntercomActive: PropTypes.bool,
    show: PropTypes.bool,
    isGreyIcon: PropTypes.bool,
    className: PropTypes.string,
};

export default memo(Intercom);
